module.exports = __webpack_public_path__ + "static/media/delaatsolar_24dpi_staging.b5eb8e03.png";